var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-message-box",
    {
      staticClass: "rb-account-updated-message-box",
      attrs: { type: "success" },
      scopedSlots: _vm._u([
        {
          key: "text",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "my_account.successfully_updated_message_box.description"
                    )
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.$t("my_account.successfully_updated_message_box.title")) +
          "\n  "
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }